import { EV } from './EventBus.js';

const KEY = 'momentum.settings.v1';

const DEFAULTS = {
  quality: 'auto',   // 'low' | 'medium' | 'high' | 'auto' (resolved at boot)
  sensitivity: 120,  // look speed, arbitrary units
  invertY: 0,
  music: 55,
  sfx: 80,
  fov: 88,
  showFps: 0,
  fullscreen: 1,
  rival: 0,
  ghost: 1,
  marker: 1,
  handle: '',
  padBinds: '',
  keyBinds: '',
  // Cross-device progress: the code IS the credential (no account), and
  // syncAt is only for showing the player when they last pushed.
  syncCode: '',
  syncAt: 0,
};

/** Persisted user preferences. Writes are debounced to one frame. */
export class Settings {
  constructor(bus) {
    this.bus = bus;
    this.values = { ...DEFAULTS };
    this._dirty = false;
    this.load();
  }

  load() {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) Object.assign(this.values, JSON.parse(raw));
    } catch (e) {
      console.warn('[settings] load failed, using defaults', e);
    }
  }

  save() {
    if (this._dirty) return;
    this._dirty = true;
    queueMicrotask(() => {
      this._dirty = false;
      try { localStorage.setItem(KEY, JSON.stringify(this.values)); }
      catch (e) { console.warn('[settings] save failed', e); }
    });
  }

  get(k) { return this.values[k]; }

  set(k, v) {
    if (this.values[k] === v) return;
    this.values[k] = v;
    this.save();
    this.bus?.emit(EV.SETTINGS_CHANGED, { key: k, value: v, values: this.values });
  }

  reset() {
    this.values = { ...DEFAULTS };
    this.save();
    this.bus?.emit(EV.SETTINGS_CHANGED, { key: '*', value: null, values: this.values });
  }
}
